module.exports = __webpack_public_path__ + "assets/img/5_1410_big.40b7da45.jpg";